import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { ContainerTemplate } from './ContainerTemplate';
import { InstalledByTable, InstalledByTableEmptyState } from '../installedBy/InstalledByTable';
import { AccessTypeTag } from '../installedBy/AccessTypeTag';
import { useFetchInstalledUsers } from '../../hooks/queries/useFetchInstalledUsers';
import { useFetchModalPermissions } from '../../hooks/queries/useFetchModalPermissions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AccessTypeItem({
  accessType,
  description
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "start",
    gap: "400",
    children: [/*#__PURE__*/_jsx(Box, {
      shrink: 0,
      children: /*#__PURE__*/_jsx(AccessTypeTag, {
        accessType: accessType
      })
    }), description]
  });
}
function AccessTypeDescription() {
  const {
    data: {
      appAccessType
    }
  } = useFetchModalPermissions();
  switch (appAccessType) {
    case 'PERSONAL':
      return /*#__PURE__*/_jsx(AccessTypeItem, {
        accessType: appAccessType,
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app-governance-lib.installedBy.description.message.personal"
        })
      });
    case 'SHARED':
      return /*#__PURE__*/_jsx(AccessTypeItem, {
        accessType: appAccessType,
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app-governance-lib.installedBy.description.message.shared"
        })
      });
    default:
      return null;
  }
}
export function InstalledBy() {
  const {
    data: {
      infoForInstalledUsers
    }
  } = useFetchInstalledUsers();
  const installedByUsersCount = infoForInstalledUsers.length;
  if (installedByUsersCount === 0) {
    return /*#__PURE__*/_jsx(InstalledByTableEmptyState, {});
  }
  return /*#__PURE__*/_jsx(ContainerTemplate, {
    description: /*#__PURE__*/_jsx(AccessTypeDescription, {}),
    children: /*#__PURE__*/_jsx(InstalledByTable, {
      users: infoForInstalledUsers
    })
  });
}